import NotificationCard from "./NotificationCard";
// import NotificationCardsVariants from "./NotificationCardVariants";

export default NotificationCard;